import { format } from "date-fns";

export function formatChatsDate(lastUpdatedAt) {
  const currentDate = new Date();
  const updatedDate = new Date(lastUpdatedAt);

  const isSameDay = currentDate.toDateString() === updatedDate.toDateString();

  const isYesterday =
    currentDate.getDate() - updatedDate.getDate() === 1 &&
    currentDate.getMonth() === updatedDate.getMonth() &&
    currentDate.getFullYear() === updatedDate.getFullYear();

  const isWithinOneWeek =
    currentDate - updatedDate <= 7 * 24 * 60 * 60 * 1000 &&
    currentDate.getFullYear() === updatedDate.getFullYear();

  // Show time with AM/PM if today
  if (isSameDay) {
    return format(updatedDate, "hh:mm a").toLowerCase(); 
  }

  // Show "Yesterday" if the date is yesterday
  if (isYesterday) {
    return "Yesterday"; 
  }

  // Show the day of the week (e.g., Monday)
  if (isWithinOneWeek) {
    return format(updatedDate, "EEEE"); 
  }

  // Show full date (e.g., 03/01/2025)
  return format(updatedDate, "MM/dd/yyyy"); 
}

export function getDate(timestamp) {
  const time = new Date(timestamp).toLocaleString("en-IN", {
    dateStyle: "short",
    timeStyle: "short",
  });
  return time;
}
export function addOneDay(date = null) {
  if(date!==undefined&&date!==null){
    date=new Date(date)
    date?.setDate(date?.getDate() + 1);
    return new Date(date).toISOString();
  }
  return date;
}
